/**
 * Top level routes
 */

export default [require('./main').default, require('./auth').default];
